import { UIView } from "uicore-ts"
import { RHForms } from "./Utils_slop/RHDesignTokens"

export class RHPanelView extends UIView {
    
    constructor(elementID?: string) {
        
        super(elementID)
        
        
        this.configureWithObject({
            // @ts-ignore
            // backgroundColor: RHColor.surface,
            backgroundColor: RHForms.panelBackgroundColor,
            // @ts-ignore
            style: {
                // borderRadius: "8px",
                borderRadius: RHForms.panelBorderRadius,
                // border: `1px solid ${RHColor.border.stringValue}`,
                border: `1px solid ${RHForms.panelBorderColor.stringValue}`,
                // boxShadow: `0 1px 3px ${RHColor.shadow.stringValue}`
                boxShadow: RHForms.panelBoxShadow
            }
        })
        
    }
    
}
